const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export async function fetchApi(
  endpoint,
  method,
  head = defaultHeaders,
  body,
  logout = fetchApi.logout,
  isSnackbar = fetchApi.isSnackbar,
) {
  const headers = { ...head, Accept: 'application/json' };
  method = method || 'GET';
  const config = {
    method,
    headers,
  };
  if (body) config.body = body;
  let data;
  const response = await fetch(endpoint, config);

  if (response.headers.get('Content-Type') === 'application/pdf') {
    data = await response.blob();
  } else {
    data = await response.json();
  }
  if (!response.ok) {
    if (response.status === 401) {
      logout();
    } else if (
      response.status === 409 &&
      data.detail.error === 'Customer not found'
    ) {
      logout();
    } else {
      if (
        typeof data.detail === 'object' &&
        !Array.isArray(data.detail) &&
        data.detail.error
      ) {
        isSnackbar({ message: data.detail.error, variant: 'error' });
      }
      if (
        typeof data.detail === 'object' &&
        Array.isArray(data.detail) &&
        data.detail.length > 0
      ) {
        data.detail.forEach((error) => {
          if (error.msg) isSnackbar({ message: error.msg, variant: 'error' });
        });
      }
    }
    throw new Error(data.detail.error);
  }
  return data;
}
